var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlipHorizontalArrow1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.5 -0.5 14 14",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flip-horizontal-arrow-1--arrow-design-flip-reflect"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 121",
    fill: "#fdba74",
    d: "m1.6965000000000001 3.688285714285714 2.595357142857143 2.0883571428571432a0.9285714285714286 0.9285714285714286 0 0 1 0 1.4467142857142858l-2.595357142857143 2.0883571428571432c-0.3296428571428571 0.2646428571428571 -0.7085 0.2720714285714286 -0.7985714285714286 -0.14114285714285715 -0.26835714285714285 -1.2173571428571428 -0.26835714285714285 -4.122857142857144 0 -5.341142857142857 0.09007142857142858 -0.41321428571428576 0.4689285714285715 -0.40671428571428575 0.7985714285714286 -0.14114285714285715Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 161",
    fill: "#fdba74",
    d: "M11.274714285714285 3.688285714285714 8.679357142857143 5.776642857142858a0.9285714285714286 0.9285714285714286 0 0 0 0 1.4467142857142858l2.595357142857143 2.0883571428571432c0.3296428571428571 0.2646428571428571 0.7085 0.2720714285714286 0.7985714285714286 -0.14114285714285715 0.26835714285714285 -1.2173571428571428 0.26835714285714285 -4.122857142857144 0 -5.341142857142857 -0.09007142857142858 -0.41321428571428576 -0.4689285714285715 -0.40671428571428575 -0.7985714285714286 -0.14114285714285715Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 157",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6.471214285714286 0.7252142857142858 0 0.9285714285714286",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 158",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6.471214285714286 4.275142857142858 0 0.9285714285714286",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 162",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1.6965000000000001 3.688285714285714 2.595357142857143 2.0883571428571432a0.9285714285714286 0.9285714285714286 0 0 1 0 1.4467142857142858l-2.595357142857143 2.0883571428571432c-0.3296428571428571 0.2646428571428571 -0.7085 0.2720714285714286 -0.7985714285714286 -0.14114285714285715 -0.26835714285714285 -1.2173571428571428 -0.26835714285714285 -4.122857142857144 0 -5.341142857142857 0.09007142857142858 -0.41321428571428576 0.4689285714285715 -0.40671428571428575 0.7985714285714286 -0.14114285714285715Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 163",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.274714285714285 3.688285714285714 8.679357142857143 5.776642857142858a0.9285714285714286 0.9285714285714286 0 0 0 0 1.4467142857142858l2.595357142857143 2.0883571428571432c0.3296428571428571 0.2646428571428571 0.7085 0.2720714285714286 0.7985714285714286 -0.14114285714285715 0.26835714285714285 -1.2173571428571428 0.26835714285714285 -4.122857142857144 0 -5.341142857142857 -0.09007142857142858 -0.41321428571428576 -0.4689285714285715 -0.40671428571428575 -0.7985714285714286 -0.14114285714285715Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 159",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6.471214285714286 7.8250714285714285 0 0.9285714285714286",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 160",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6.471214285714286 11.375 0 0.9285714285714286",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipHorizontalArrow1);
export default __webpack_public_path__ + "static/media/flip-horizontal-arrow-1.b5d17afa5c1a67f2e65ac2131f9198e8.svg";
export { ForwardRef as ReactComponent };